import React, { useState } from "react";
import Tooltip from "@hig/tooltip";
import { 
  SEARCH_OPTION_NONE, 
  SEARCH_OPTION_WHOLE_WORD 
} from "../utilities/searchManager";
import WholeWordIcon from "../images/whole-word-default.svg";
import WholeWordIconHover from "../images/whole-word-hover.svg";

function SearchOptions({ searchType, setSearchType }) {
  const [isHover, setIsHover] = useState(false);

  return (
    <div
      className={`search-options`}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <Tooltip
        anchorPoint="top-center"
        openOnHover="true"
        className="hover-tooltip"
        content={
          <div className="hover-tooltip-content">
            Whole-word search is{" "}
            <b>{searchType & SEARCH_OPTION_WHOLE_WORD ? "on" : "off"}</b>
          </div>
        }
      >
        <img
          id="whole-word-btn"
          className={`whole-word-btn  ${
            searchType & SEARCH_OPTION_WHOLE_WORD ? "selected" : ""
          }`}
          src={isHover ? WholeWordIconHover : WholeWordIcon}
          alt="Whole-word match"
          onClick={() =>
            setSearchType(
              searchType & SEARCH_OPTION_WHOLE_WORD
                ? SEARCH_OPTION_NONE
                : SEARCH_OPTION_WHOLE_WORD
            )
          }
        />
      </Tooltip>
    </div>
  );
}

export default SearchOptions;
